import { render, staticRenderFns } from "./document-library.vue?vue&type=template&id=10a2811f&scoped=true"
import script from "./document-library.vue?vue&type=script&lang=js"
export * from "./document-library.vue?vue&type=script&lang=js"
import style0 from "./document-library.vue?vue&type=style&index=0&id=10a2811f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10a2811f",
  null
  
)

export default component.exports